import { render, staticRenderFns } from "./faturamentoChartSideBar.vue?vue&type=template&id=07330f9a"
import script from "./faturamentoChartSideBar.vue?vue&type=script&lang=js"
export * from "./faturamentoChartSideBar.vue?vue&type=script&lang=js"
import style0 from "./faturamentoChartSideBar.vue?vue&type=style&index=0&id=07330f9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports